// About Section Component
import { I18nManager } from "../../services/i18n-manager";

export class AboutSection {
  private i18nManager: I18nManager;

  constructor(i18nManager: I18nManager) {
    this.i18nManager = i18nManager;
  }

  init(): void {
    this.setupEventListeners();
    this.updateContent();
  }

  private setupEventListeners(): void {
    // Listen for language changes
    this.i18nManager.onLanguageChange(() => {
      this.updateContent();
    });
  }

  private updateContent(): void {
    // Update section title
    const sectionTitle = document.querySelector(
      ".about-section .section-title"
    );
    if (sectionTitle) {
      sectionTitle.textContent = this.i18nManager.t("about.title");
    }

    // Update paragraphs
    const paragraph1 = document.querySelector(
      ".about-section .about-paragraph-1"
    );
    if (paragraph1) {
      paragraph1.textContent = this.i18nManager.t("about.paragraph1");
    }

    const paragraph2 = document.querySelector(
      ".about-section .about-paragraph-2"
    );
    if (paragraph2) {
      paragraph2.textContent = this.i18nManager.t("about.paragraph2");
    }

    const paragraph3 = document.querySelector(
      ".about-section .about-paragraph-3"
    );
    if (paragraph3) {
      paragraph3.textContent = this.i18nManager.t("about.paragraph3");
    }

    // Update service items
    const serviceItems = document.querySelectorAll(
      ".about-section .about-service-item"
    );
    serviceItems.forEach((item, index) => {
      const key = `about.service${index + 1}`;
      const text = this.i18nManager.t(key);
      if (text && text !== key) {
        item.textContent = text;
      }
    });
  }
}

